import type { ItemCardType } from '../../type/common.type';
import { DeliveryDateData, ShippingBadgeData } from '../../type/common.type';
import { ItemCardBottom } from './parts/ItemCardBottom';
import { ItemCardCounter } from './parts/ItemCardCounter';
import { ItemCardHeader } from './parts/ItemCardHeader';
import { ItemCardInfo } from './parts/ItemCardInfo';
import { ItemCardMinimumOrder } from './parts/ItemCardMinimumOrder';
import { ItemCardPrice } from './parts/ItemCardPrice';
import { ItemCardPriceSection } from './parts/ItemCardPriceSection';
import { ItemCardProduct } from './parts/ItemCardProduct';
import { ItemCardRemove } from './parts/ItemCardRemove';
import { ItemCardRoot } from './parts/ItemCardRoot';
import { ItemCardShipping } from './parts/ItemCardShipping';
import { ItemCardStock } from './parts/ItemCardStock';

export interface ItemCardShippingInfo {
  badge: ShippingBadgeData;
  delivery_date: DeliveryDateData | null;
}

export interface ItemCardState {
  item: ItemCardType;
  /** 가격 표시 여부 */
  displayPrice?: boolean;
  /** 수량 카운터 표시 여부 */
  displayCounter?: boolean;
  /** 상품 정보 표시 여부 */
  displayProductInfo?: boolean;
  /** 감소 버튼 비활성화 여부 */
  disableMinCounter?: boolean;
  /** 최대 수량 카운터 버튼 비활성화 여부 */
  disableMaxCounter?: boolean;
  /** 1+N 뱃지 이미지 URL */
  bogoBadgeUrl?: string;
  /** 배송 데이터 */
  shipping?: ItemCardShippingInfo;
}
interface ItemCardProps extends ItemCardState {
  handleIncrease: () => void;
  handleDecrease: () => void;
  handleRemove?: () => void;
}

export const ItemCard = ({
  item,
  displayPrice = true,
  displayCounter = true,
  displayProductInfo = true,
  disableMinCounter = false,
  disableMaxCounter = false,
  bogoBadgeUrl,
  shipping,
  handleIncrease = () => undefined,
  handleDecrease = () => undefined,
  handleRemove,
}: ItemCardProps) => {
  const display_product_info = displayProductInfo && Boolean(item.minimum_order_quantity || item.remain_stock);
  return (
    <ItemCard.Root>
      <ItemCard.Header>
        <ItemCard.Product option_name={item.display_name} bogo_badge_url={bogoBadgeUrl} />
        {handleRemove && <ItemCard.Remove handleRemove={handleRemove} />}
      </ItemCard.Header>

      {shipping && <ItemCard.Shipping badge={shipping.badge} delivery_date={shipping.delivery_date} />}

      {(displayCounter || displayPrice || display_product_info) && (
        <ItemCard.Bottom>
          {displayCounter ? (
            <ItemCard.Counter
              count={item.count}
              disable_min_disabled={disableMinCounter}
              disable_max_disabled={disableMaxCounter}
              handleIncrease={handleIncrease}
              handleDecrease={handleDecrease}
            />
          ) : (
            <div />
          )}

          <ItemCard.PriceSection>
            {displayPrice && <ItemCard.Price price={item.price} count={item.count} />}
            {display_product_info && (
              <ItemCard.Info>
                {Boolean(item.remain_stock) && <ItemCard.Stock remain_stock={item.remain_stock ?? 0} />}
                {Boolean(item.minimum_order_quantity) && <ItemCard.MinimumOrder count={item.minimum_order_quantity} />}
              </ItemCard.Info>
            )}
          </ItemCard.PriceSection>
        </ItemCard.Bottom>
      )}
    </ItemCard.Root>
  );
};

ItemCard.Root = ItemCardRoot;
ItemCard.Header = ItemCardHeader;
ItemCard.Product = ItemCardProduct;
ItemCard.Remove = ItemCardRemove;
ItemCard.Shipping = ItemCardShipping;
ItemCard.Bottom = ItemCardBottom;
ItemCard.Counter = ItemCardCounter;
ItemCard.PriceSection = ItemCardPriceSection;
ItemCard.Price = ItemCardPrice;
ItemCard.Info = ItemCardInfo;
ItemCard.Stock = ItemCardStock;
ItemCard.MinimumOrder = ItemCardMinimumOrder;
